<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-btn color="primary" class="mb-5" dark @click="open_generate_order = true">Crear Orden</v-btn>

      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col pt-0">
                  <v-menu
                    ref="desde_selected"
                    v-model="desde_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="desde_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="state_selected != null && (state_selected.id == service.STATE_PENDING || state_selected.id == service.STATE_PARTIALLY)"
                        v-model="desde_selected"
                        label="Desde"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="pt-0 mt-0"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col pt-0">
                  <v-menu
                    ref="hasta_selected"
                    v-model="hasta_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="hasta_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="state_selected != null && (state_selected.id == service.STATE_PENDING || state_selected.id == service.STATE_PARTIALLY)"
                        v-model="hasta_selected"
                        label="Hasta"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="pt-0 mt-0"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col pt-0">
                  <v-text-field clearable v-model="sale_order_number_selected" autocomplete="off" class="pt-0 mt-0" label="Nº de Orden"></v-text-field>
                </div>

                <div class="col pt-0">
                  <v-combobox
                    v-model="state_selected"
                    autocomplete="off"
                    data-vv-as="state_selected"
                    name="state_selected"
                    item-text="name"
                    item-value="id"
                    :items="states"
                    label="Estado"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>
              </div>

              <div class="row">
                <div class="col pt-0">
                  <v-combobox
                    v-model="emitter_selected"
                    autocomplete="off"
                    data-vv-as="emitter_selected"
                    name="emitter_selected"
                    item-text="name"
                    item-value="id"
                    :items="emitters"
                    label="Emisor"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col pt-0">
                  <v-combobox
                    v-model="receiver_selected"
                    autocomplete="off"
                    data-vv-as="receiver_selected"
                    name="receiver_selected"
                    item-text="name"
                    item-value="id"
                    :items="receivers"
                    label="Receptor"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col pt-0">
                  <v-combobox v-model="client_selected" autocomplete="off" item-text="name" item-value="id" :items="clients" label="Cliente" class="pt-0 mt-0" clearable></v-combobox>
                </div>

                <div class="col pt-0" v-if="isProductCompany()">
                  <v-combobox
                    v-model="product_selected"
                    autocomplete="off"
                    data-vv-as="product_selected"
                    name="product_selected"
                    item-text="name"
                    item-value="id"
                    :items="products"
                    label="Producto"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col pt-0" style="display: flex; justify-content: end">
                  <v-btn color="blue-grey mr-2" dark @click="exportToExcel"> Exportar </v-btn>

                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="isProductCompany() ? headers : headers_services"
          :items="list"
          :search="search"
          :custom-filter="customFilter"
          :loading="loading"
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
        >
          <template v-slot:item="props">
            <tr>
              <td class="no-wrap">{{ props.item.cbte_fch }}</td>
              <td>
                <div class="no-wrap">{{ props.item.sale_order_number != null ? props.item.sale_order_number.toString().padStart(8, "0") : "-" }}</div>
                <v-tooltip v-if="props.item.external_reference" bottom>
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="text-truncate table-cell-truncate-ref table-text-secondary">{{ props.item.external_reference }}</div>
                  </template>
                  <span>{{ props.item.external_reference }}</span>
                </v-tooltip>
              </td>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="text-truncate table-cell-truncate-wide">
                      {{ props.item.receiver_name }}<span v-if="getClientName(props.item)"> - {{ getClientName(props.item) }}</span>
                    </div>
                  </template>
                  <span>{{ props.item.receiver_name }}{{ getClientName(props.item) ? " - " + getClientName(props.item) : "" }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="text-truncate table-cell-truncate table-text-secondary">{{ props.item.emitter_name }}</div>
                  </template>
                  <span>{{ props.item.emitter_name }}</span>
                </v-tooltip>
              </td>
              <td class="text-right"><ImporteMoneda :item="props.item" /></td>
              <td v-if="isProductCompany()" v-html="calculateDaysLeft(props.item.estimated_delvery_date, props.item)"></td>
              <td>
                <div class="status-badge font-weight-medium" :class="'order-status-' + props.item.state_id">
                  {{ props.item.state_name }}
                </div>
              </td>

              <td class="text-right px-0 pr-3" style="min-width: 160px">
                <v-tooltip bottom v-if="props.item.state_id == ordersState.STATE_PARTIALLY || props.item.state_id == ordersState.STATE_FINALISHED">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewComprobantes(props.item)"> article </v-icon>
                  </template>
                  <span>Ver facturas asociadas</span>
                </v-tooltip>

                <v-tooltip bottom v-if="props.item.state_id == ordersState.STATE_PARTIALLY || props.item.state_id == ordersState.STATE_PENDING">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="green" small class="mr-2" @click="generateInvoiceModal(props.item)">post_add</v-icon>
                  </template>
                  <span>Generar factura</span>
                </v-tooltip>

                <v-tooltip bottom v-if="props.item.state_id == ordersState.STATE_PARTIALLY">
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="orange" class="mr-2" @click="openDialogEndSaleOrder(props.item)"> door_front </v-icon>
                  </template>
                  <span>Finalizar Orden</span>
                </v-tooltip>

                <!-- tiene alguna condicion para poder editar? -->
                <v-tooltip bottom v-if="props.item.state_id == ordersState.STATE_PENDING">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)"> edit </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewSaleOrder(props.item)"> remove_red_eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom v-if="isProductCompany() && props.item.state_id != ordersState.STATE_CANCELED">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="grey" class="mr-2" @click="editItemDelivered(props.item)"> local_shipping </v-icon>
                  </template>
                  <span>Editar entrega</span>
                </v-tooltip>

                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small color="purple" class="mr-2" v-bind="attrs" v-on="on"> print </v-icon>
                  </template>

                  <v-list>
                    <v-list-item dense @click="printItem(props.item)">
                      <v-list-item-title>Descargar Orden de Venta</v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="printItem(props.item, true)">
                      <v-list-item-title>Ver Orden de Venta</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-tooltip bottom v-if="props.item.state_id == ordersState.STATE_PENDING">
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="black" class="mr-2" @click="openDialogCancelSaleOrder(props.item)"> close </v-icon>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>

                <v-tooltip bottom v-if="props.item.state_id == ordersState.STATE_PENDING">
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="deleteItem(props.item)"> delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogGenerarSaleOrder
        :title="isViewModal() ? 'Ver Orden de Venta' : 'Generar Orden de Venta'"
        :open="open_generate_order"
        :isViewModal="isViewModal()"
        :order_to_cancel="order_to_cancel"
        @closeDialog="closeSaleOrder"
        @reload="filter"
        @updateMainItem="updateMainItem"
        :item="mainItem"
      />

      <DialogUpdateDelivered title="Editar fecha de entrega" :open="dialog_delivered" @closeDialog="closeUpdateDelivered" @reload="filter" @updateMainItem="updateMainItem" :item="mainItem" />

      <DialogYesNo
        :title="title_cancel_order"
        :message="message_cancel_order"
        :open="dialog_cancel_order"
        :loading="loading_dialog_order"
        @accept="cancelSaleOrder"
        @cancel="closeDialogCancelSaleOrder"
        @reload="filter"
      />
      <DialogYesNo
        :title="title_cancel_order"
        :message="message_cancel_order"
        :open="dialog_end_order"
        :loading="loading_dialog_order"
        @accept="endSaleOrder"
        @cancel="closeDialogEndSaleOrder"
        @reload="filter"
      />

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" @reload="filter" />

      <DialogViewComprobantes title="Facturas asociadas" :open="dialog_view_comprobantes" :sale_order_id="sale_order_id" @closeDialog="closeViewComprobantes" />

      <DialogGenerarComprobante
        title="Generar Comprobante"
        :open="open_generate_comprobante"
        :invoice_to_cancel="invoice_to_cancel"
        @closeDialog="closeInvoice"
        @reload="filter"
        @updateMainItem="updateMainItem"
        :sale_order="mainItem"
        @openModalRemito="openModalRemito"
      />

      <ModalRemito v-if="update_access && dialog_remito" :voucher="voucherForRemito" formBtn="Crear" :dialog="dialog_remito" @closeDialog="cancelModalRemito" @updateItem="(newItem) => {}" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { ordersState } from "@/constants/ordersState";
import { generalService } from "@/libs/ws/generalService";
import { clientsService } from "@/libs/ws/clientsService";
import { saleOrderService } from "@/libs/ws/saleOrderService";
import { emmiterService } from "@/libs/ws/emmiterService";
import { receiversService } from "@/libs/ws/receiversService";
import { formatUtils } from "@/libs/utils/formatUtils";
import { tableUtils } from "@/libs/utils/tableUtils";
import ImporteMoneda from "@/components/Comprobantes/ImporteMoneda.vue";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import DialogGenerarSaleOrder from "./DialogGenerarSaleOrder.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";
import DialogGenerarComprobante from "@/views/Billing/Vouchers/DialogGenerarComprobante.vue";
import DialogViewComprobantes from "./DialogViewComprobantes.vue";
import ModalRemito from "@/views/Remitos/ModalRemito.vue";
import DialogUpdateDelivered from "./DialogUpdateDelivered.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
export default {
  components: { Title, ImporteMoneda, DialogGenerarSaleOrder, DialogUpdateDelivered, ModalRemito, DialogYesNo, DialogDelete, DialogGenerarComprobante, DialogViewComprobantes },
  mixins: [GenericMixin, RolMixin, SettingsMixin],
  data() {
    return {
      formatUtils: formatUtils,
      ordersState: ordersState,
      parent: this,
      service: saleOrderService,
      page_title: "Ordenes de Venta",
      modal_title: "Orden de Venta",
      mainItem: {
        id: "",
        creation_date: "",
        emitter: "",
        receiver: "",
        imp_tot_conc: "",
        imp_neto: "",
        imp_total: "",
        dolar_cotiz: null,
        sale_order_number: null,
        external_reference: null,
        estimated_delvery_date: "",
        delivered: false,
      },
      dialog_delete: false,
      loading_dialog: false,
      title_cancel_order: "",
      message_cancel_order: "",
      dialog_cancel_order: false,
      dialog_end_order: false,
      loading_dialog_order: false,
      sale_order_id_cancel: null,
      defaultItem: null,
      headers: [
        { text: "Fecha", align: "left", sortable: true, value: "cbte_fch", width: 90, class: "no-wrap" },
        { text: "Nº Orden", align: "left", sortable: true, value: "sale_order_number", width: 130 },
        { text: "Receptor / Emisor", align: "left", sortable: true, value: "receiver_name" },
        { text: "Total", align: "end", sortable: true, value: "total_ars", width: 150 },
        { text: "Entrega", align: "left", sortable: true, value: "estimated_delvery_date", width: 140 },
        { text: "Estado", align: "left", sortable: true, value: "state_name", width: 110 },
        { text: "Acción", value: "", align: "end", width: 160 },
      ],
      headers_services: [
        { text: "Fecha", align: "left", sortable: true, value: "cbte_fch", width: 90, class: "no-wrap" },
        { text: "Nº Orden", align: "left", sortable: true, value: "sale_order_number", width: 130 },
        { text: "Receptor / Emisor", align: "left", sortable: true, value: "receiver_name" },
        { text: "Total", align: "end", sortable: true, value: "total_ars", width: 150 },
        { text: "Estado", align: "left", sortable: true, value: "state_name", width: 110 },
        { text: "Acción", value: "", align: "end", width: 160 },
      ],
      list: [],
      states: [],
      emitters: [],
      receivers: [],
      clients: [],
      products: [],
      costs_centers: [],
      open_generate_order: false,
      desde_selected_open: false,
      hasta_selected_open: false,
      sale_order_number_selected: null,
      client_selected: null,
      emitter_selected: null,
      receiver_selected: null,
      product_selected: null,
      state_selected: null,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      order_to_cancel: null,
      invoice_to_cancel: null,
      total: 0.0,
      total_iva: 0.0,
      open_generate_comprobante: false,
      dialog_view_comprobantes: false,
      sale_order_id: 0,
      voucherForRemito: null,
      dialog_remito: false,
      dialog_delivered: false,
    };
  },
  mounted() {
    this.loadComboData();
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service, this.getFilterParams());
  },
  computed: {
    customFilter() {
      return tableUtils.buildCustomFilter([
        "cbte_fch",
        "sale_order_number",
        (item) => (item.sale_order_number != null ? item.sale_order_number.toString().padStart(8, "0") : null),
        "imp_total",
        "external_reference",
        "receiver_name",
        "client_name",
        "emitter_name",
        "mon_name",
        "total_ars",
        "total_usd",
        "state_name",
        "estimated_delvery_date",
      ]);
    },
  },
  methods: {
    //El listado trae filas planas: para los modales se pide el objeto completo por id
    async requestSaleOrder(id) {
      try {
        const response = await this.service.get(id);
        if (response.status === true) return response.result;
        this.$toast.error(response.msg, "Error");
      } catch (e) {
        console.log("saleOrderService.get error");
        console.log(e);
        this.$toast.error("Error al obtener la orden de venta", "Error");
      }
      return null;
    },
    async fetchSaleOrder(id) {
      this.loading = true;
      const sale_order = await this.requestSaleOrder(id);
      this.loading = false;
      return sale_order;
    },
    getClientName(item) {
      return tableUtils.getReceiverClientName({ name: item.receiver_name, client: { name: item.client_name } });
    },
    async editItemDelivered(item) {
      this.errors.clear();
      const sale_order = await this.fetchSaleOrder(item.id);
      if (sale_order == null) return;

      this.editedIndex = this.list.indexOf(item);
      this.mainItem = sale_order;
      this.dialog_delivered = true;
    },
    cancelModalRemito() {
      this.voucherForRemito = null;
      this.dialog_remito = false;
    },
    openModalRemito(item) {
      this.errors.clear();
      //this.mainItem = Object.assign({}, item);
      this.voucherForRemito = JSON.parse(JSON.stringify(item));
      this.dialog_remito = true;
    },
    calculateDaysLeft(deliveryDate, item) {
      if (item.delivered) {
        return '<span class="entregada">Entregada</span>';
      }

      if (item.state_id == ordersState.STATE_CANCELED) {
        return '<span class="">-</span>';
      }
      const currentDate = new Date();
      const delivery = new Date(deliveryDate);

      const differenceInTime = delivery - currentDate;
      const daysLeft = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24)); // Convertir milisegundos a días

      if (daysLeft > 0) {
        return `<span class="por_vencer">Entrega en ${daysLeft} días</span>`;
      } else if (daysLeft === 0) {
        return '<span class="vence_hoy">Entrega hoy</span>';
      } else {
        return `<span class="vencida">Retraso de ${daysLeft * -1} días</span>`;
      }
    },
    viewComprobantes(item) {
      this.sale_order_id = item.id;
      this.dialog_view_comprobantes = true;
    },
    updateMainItem() {
      this.mainItem = JSON.parse(JSON.stringify(this.defaultItem));
    },
    async editItem(item) {
      this.errors.clear();
      const sale_order = await this.fetchSaleOrder(item.id);
      if (sale_order == null) return;

      this.editedIndex = this.list.indexOf(item);
      this.mainItem = sale_order;
      this.open_generate_order = true;
    },
    async viewSaleOrder(item) {
      this.errors.clear();
      const sale_order = await this.fetchSaleOrder(item.id);
      if (sale_order == null) return;

      this.viewdIndex = this.list.indexOf(item);
      this.mainItem = sale_order;
      this.open_generate_order = true;
    },
    isViewModal() {
      return this.formBtn == "";
    },
    closeSaleOrder() {
      this.viewdIndex = -1;
      this.open_generate_order = false;
      this.order_to_cancel = null;
    },
    closeUpdateDelivered() {
      this.dialog_delivered = false;
    },
    loadList(service, param = null) {
      this.loading = true;

      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      service
        .filter(param)
        .then((response) => {
          this.list = response.result;
          this.loading = false;
          this.getTotal();
          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.loading = false;
        });
    },
    getTotal() {
      this.total = 0;
      this.total_iva = 0;

      if (this.list && this.list.length > 0) {
        this.list.forEach((element) => {
          this.total_iva = (parseFloat(this.total_iva) + parseFloat(element.imp_iva)).toFixed(2);

          //nota de credito ya viene en negativo.
          this.total = (parseFloat(this.total) + parseFloat(element.imp_total) - parseFloat(element.imp_iva) - parseFloat(element.imp_trib)).toFixed(2);
        });
      }
    },
    getFilterParams() {
      const param = {
        raw: true, //El listado se resuelve por SQL: filas planas, sin objetos de Doctrine
        from: this.desde_selected,
        to: this.hasta_selected,
        emitter: this.emitter_selected != null ? this.emitter_selected.id : null,
        receiver: this.receiver_selected != null ? this.receiver_selected.id : null,
        client: this.client_selected != null ? this.client_selected.id : null,
        product: this.product_selected != null ? this.product_selected.id : null,
        state: this.state_selected != null ? this.state_selected.id : null,
        sale_order_number: this.sale_order_number_selected,
      };
      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    loadComboData() {
      saleOrderService.list_states().then((response) => {
        this.states = response.result;
      });
      emmiterService.filter({ enabled: true }).then((response) => {
        this.emitters = response.result;
      });
      clientsService.filterMinify().then((response) => {
        this.clients = response.result;
      });
      receiversService.filter({}).then((response) => {
        this.receivers = response.result;
      });
      generalService.filter({}, Constant.SECTION_PRODUCTS).then((response) => {
        this.products = response.result;
      });
    },
    exportToExcel() {
      if (this.loading) return;
      this.loading = true;
      let param = this.getFilterParams();

      this.service
        .export_filter(param)
        .then((response) => {
          if (Object.prototype.toString.call(response) != "[object ArrayBuffer]" && !response.status) {
            this.$toast.error(response.msg, "Error");
            this.loading = false;
            return;
          }

          let blob = new Blob([response], {
            type: "application/vnd.ms-excel",
          });
          let link = document.createElement("a");
          //link.setAttribute('download', "export")
          link.download = "sale_orders.xlsx";
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          link.click();
          this.loading = false;
        })
        .catch((e) => {
          console.log("service.export_filter sale orders error");
          console.log(e);
          this.loading = false;
        });
    },

    printItem(item, open = false) {
      this.loading = true;
      saleOrderService
        .print(item.id)
        .then((response) => {
          let nombre = item.sale_order_number.toString().padStart(8, "0");
          if (!generalService.downloadPdf(response, item.receiver_name + "_" + nombre + ".pdf", open)) {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          this.$toast.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteItemConfirm() {
      this.loading = true;
      saleOrderService
        .remove({ id: this.deleteId })
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");
            this.loadList(this.service, this.getFilterParams());
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((e) => {
          console.log("saleOrderService.filter error");
          console.log(e);
          this.$toast.error("Error exception", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
      this.dialog_delete = false;
    },

    cancelInvoice(item) {
      this.order_to_cancel = item;
      this.open_generate_order = true;
    },

    async generateInvoiceModal(item) {
      const sale_order = await this.fetchSaleOrder(item.id);
      if (sale_order == null) return;

      this.editedIndex = this.list.indexOf(item);
      this.mainItem = sale_order;
      this.open_generate_comprobante = true;
    },
    closeInvoice() {
      this.open_generate_comprobante = false;
      this.mainItem = JSON.parse(JSON.stringify(this.defaultItem));
    },
    closeViewComprobantes() {
      this.dialog_view_comprobantes = false;
    },
    cancelSaleOrder() {
      this.loading_dialog_order = true;
      const param = {
        id: this.sale_order_id_cancel,
      };
      saleOrderService
        .cancel_sale_order(param)
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");
            this.loadList(this.service, this.getFilterParams());
            this.dialog_cancel_order = false;
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((e) => {
          console.log("saleOrderService.cancelSaleOrder error");
          console.log(e);
          this.$toast.error("Error exception", "Error");
        })
        .finally(() => {});
    },
    closeDialogCancelSaleOrder() {
      this.title_cancel_order = "";
      this.message_cancel_order = "";
      this.sale_order_id_cancel = null;
      this.loading_dialog_order = false;
      this.dialog_cancel_order = false;
    },
    openDialogCancelSaleOrder(item) {
      this.title_cancel_order = "Orden de venta " + item.sale_order_number;
      this.message_cancel_order = "¿Esta seguro que desea cancelar la orden de venta " + item.sale_order_number + "?";
      this.loading_dialog_order = false;
      this.sale_order_id_cancel = item.id;
      this.dialog_cancel_order = true;
    },
    openDialogEndSaleOrder(item) {
      this.title_cancel_order = "Orden de venta " + item.sale_order_number;
      this.message_cancel_order = "¿Esta seguro que desea finalizar la orden de venta " + item.sale_order_number + "?";
      this.loading_dialog_order = false;
      this.sale_order_id_cancel = item.id;
      this.dialog_end_order = true;
    },
    endSaleOrder() {
      this.loading_dialog_order = true;
      const param = {
        id: this.sale_order_id_cancel,
      };
      saleOrderService
        .end_sale_order(param)
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");
            this.loadList(this.service, this.getFilterParams());
            this.dialog_end_order = false;
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((e) => {
          console.log("saleOrderService.end_sale_order error");
          console.log(e);
          this.$toast.error("Error exception", "Error");
        })
        .finally(() => {});
    },
    closeDialogEndSaleOrder() {
      this.title_cancel_order = "";
      this.message_cancel_order = "";
      this.sale_order_id_cancel = null;
      this.loading_dialog_order = false;
      this.dialog_end_order = false;
    },
  },
};
</script>
